import { Component, OnInit, Input } from '@angular/core';
import { DateTimeDataElement } from '../../../../core/elements/models/datetime.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SimulatorEngineService } from '../../../../core/services/simulator-engine.service';

@Component({
  selector: 'acr-assist-date-time-element',
  template: `<form [formGroup]="dateTimeElementForm" novalidate *ngIf="dateTimeDataElement.isVisible">
  <div class="form-group">
    <div class="col-sm-5 text-right">
      <label class="control-label break-word">
        <!-- {{dateTimeDataElement | json}} -->
        {{dateTimeDataElement.label}}
        <span *ngIf="dateTimeDataElement.unit != undefined && dateTimeDataElement.unit != ''"> ({{dateTimeDataElement.unit}})</span>
      </label>
      <ng-container *ngIf="dateTimeDataElement.hint !== '' && dateTimeDataElement.hint !== undefined">
        <i class="fa fa-info-circle text-primary whitespace" title="{{dateTimeDataElement.hint}}"></i>
      </ng-container>
      <!-- <ng-container *ngIf="dateTimeDataElement.diagrams != undefined ">
        <acr-hint-diagram [dataElement]="dateTimeDataElement" [imagePath]="imagePath"></acr-hint-diagram>
      </ng-container> -->
      <ng-container *ngIf="this.dateTimeDataElement.isRequired">
          <span *ngIf="dateTimeElementForm.controls['dateTimeElement'].invalid">
            <span *ngIf="dateTimeElementForm.controls['dateTimeElement'].errors.required" class="required-field" title="Required Field">
              *
            </span>
          </span>
        </ng-container>
    </div>
    <div class="col-sm-7">      
      <div [ngClass]="dateTimeDataElement.isEditable == false ? 'disabled-picker' : ''">
          <angular2-date-picker  formControlName="dateTimeElement" [(ngModel)]="date" [settings]="settings"></angular2-date-picker>
      </div>     
    </div>
  </div>
</form>
`,
  styles: [`.dec-btn[_ngcontent-c13],.inc-btn[_ngcontent-c13],.ng-scope.wc-time-sec.wc-time-sec[_ngcontent-c13]{cursor:pointer}.wc-date-container[_ngcontent-c13],.wc-date-container[_ngcontent-c13]>span[_ngcontent-c13]{color:#000!important}.disabled-picker{cursor:not-allowed}.disabled-picker:before{content:"";z-index:1;position:absolute;top:0;right:0;bottom:0;left:0;background-color:rgba(255,255,255,.8)}.required-field{color:red}`]
})
export class AssistDateTimeElementComponent implements OnInit {
  @Input() dateTimeDataElement: DateTimeDataElement;
  dateTimeElementForm: FormGroup;
  date = new Date();
  settings = {
    bigBanner: true,
    format: 'dd-MMM-yyyy hh:mm a',
    defaultOpen: false,
    timePicker: true,
    closeOnSelect: true,
    // disabled: true
};

  constructor(private formBuilder: FormBuilder, private simulatorEngineService: SimulatorEngineService) { }

  ngOnInit() {
    this.createDateTimeElementForm();
  }

  onDateSelect(){
    // alert();
  }

  private createDateTimeElementForm() {
    this.dateTimeElementForm = this.formBuilder.group({
      dateTimeElement: ['', Validators.compose([Validators.required, Validators.min(+0), Validators.max(+1)])],
    });
  }
}

